import { Instance, types } from 'mobx-state-tree';
import { RTModel } from './RTModel';

const TutorSessionRoomManagerState = RTModel.named('TutorSessionRoomManagerState').props({
  room_list: types.array(types.string),
});

export default TutorSessionRoomManagerState;
export interface ITutorSessionRoomManagerState extends Instance<typeof TutorSessionRoomManagerState> {}
